import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

import { ROUTE_PATH_ADMIN_SOFTWARES_LIST } from "src/modules/data-protection/constants";

const UsedFor = ({ t }) => {
    return (
        <Card>
            <CardBody>
                <h4 className="card-title">{t("Used for")}</h4>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="d-flex align-items-start">
                        <div className="avatar-xs rounded me-2 flex-shrink-0">
                            <span className="avatar-title rounded bg-soft-primary text-primary">
                                <i className="ri-check-line" />
                            </span>
                        </div>
                        <div>
                            <div>{t("Privacy Risk Approvals")}</div>
                            <div className="text-muted">
                                {t(
                                    "This user may receive approval requests when a DPO approval is required."
                                )}
                            </div>
                        </div>
                    </div>
                    <Link
                        to={ROUTE_PATH_ADMIN_SOFTWARES_LIST}
                        className="flex-shrink-0"
                    >
                        {t("Go to approval")}
                    </Link>
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(UsedFor);
